import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CardImageSignin from "../components/signin/cardImageSignin";
import singinPic2 from "../assets/image/studentInformation.png";
import singinPic3 from "../assets/image/boy.png";
import singinPic4 from "../assets/image/callInfo.png";
import done from "../assets/image/doneSignin.png";
import Vector from "../assets/SVG/vector";
import SigninFormMujahid from "../components/signin/signinFormMujahid";
import SigninFormMujahid2 from "../components/signin/signinFormMujahid2";
import SigninFormMujahid3 from "../components/signin/signinFormMujahid3";
import { Link } from "react-router-dom";
import { getMyInformation } from "../api/signin";
import logo from "../assets/image/logo.png";

export default function SigninMujahid() {
  const [update, setUpdate] = useState(false);
  const [level, setLevel] = useState(1);
  const [dataForm1, setDataForm1] = useState({
    name: "",
    fatherName: "",
    birthDay: "",
    field: "",
    university: "",
    universityYear: "",
    nid: "",
    phone: "",
    sex: "MALE",
  });
  const [dataCheckCode, setDataCheckCode] = useState({
    token: "",
    phone: "",
    code: 0,
  });
  const [dataForm2, setDataForm2] = useState({
    abilities: "",
    diseases: "",
    allergies: "",
    bloodType: "",
  });
  const [dataFinal, setDataFinal] = useState({
    phone: "",
    abilities: "",
    diseases: "",
    allergies: "",
    bloodType: "",
    nearbyName: "",
    nearbyPhone: "",
    nearbyRel: "",
    groupCode: "",
    password: "",
    passwordRepeat: "",
  });
  const [dataAll, setDataAll] = useState();
  useEffect(() => {
    if (window.location.search.split("?", 2)[1]) {
      getMyInformation()
        .then((x) => {
          setDataAll(x);
          setUpdate(true);
        })
        .catch((z) => console.log(z));
    }
  }, []);
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="left"
      style={{
        background: "linear-gradient(180deg, #6cbbc7 0%, #6cbbc7 100%)",
      }}
      width="100vw"
      height="100vh"
      position="fixed"
    >
      {level !== 4 && (
        <>
          <Box height="auto" width="100%">
            <Box m="30px" mt="-20px">
              <img style={{ width: "100px", height: "auto" }} src={logo} />
            </Box>
            <CardImageSignin
              value={level}
              image={
                level === 1 ? singinPic2 : level === 2 ? singinPic3 : singinPic4
              }
              title={
                level === 1
                  ? "مشخصات کلی"
                  : level === 2
                  ? "اطلاعات تخصصی"
                  : "اطلاعات آشنایان و امنیت حساب"
              }
              text={
                level === 1
                  ? "لطفاً مشخصات خود را با دقت وارد کنید تا ثبت نام به درستی انجام شود. اطلاعات شما محرمانه بوده و صرفاً برای اهداف ثبت نام استفاده خواهد شد."
                  : level === 2
                  ? "در بخش مربوطه، مهارت‌ها و بیماری‌های زمینه‌ای خود را وارد کنید. اطلاعات محرمانه و تنها برای اطلاع از وضعیت جسمی شما است."
                  : "لطفاً اطلاعات تماس آشنایان درجه یک را وارد کنید. این اطلاعات به منظور موارد ضروری در صورت لزوم استفاده خواهد شد و کاملاً محرمانه خواهد ماند."
              }
            />
          </Box>
          <Box className="cardLogin" bgcolor="white" ml="14px">
            <Box display="flex" justifyContent="left">
              {level === 1 && (
                <Link
                  to={window.location.search.split("?", 2)[1] ? "/" : "/signin"}
                >
                  <Box
                    sx={{ cursor: "pointer" }}
                    width="fit-content"
                    m="30px 40px"
                  >
                    <Vector />
                  </Box>
                </Link>
              )}
            </Box>
            <Box display={"grid"} justifyContent="center">
              {level === 1 && (
                <SigninFormMujahid
                  dataFormFinal={dataFinal}
                  setDataFormFinal={setDataFinal}
                  setDataCheckCode={setDataCheckCode}
                  dataCheckCode={dataCheckCode}
                  setDataForm={setDataAll || setDataForm1}
                  dataForm={dataAll || dataForm1}
                  setLevel={setLevel}
                  update={update}
                />
              )}
              {level === 2 && (
                <SigninFormMujahid2
                  dataFormFinal={dataAll || dataFinal}
                  setDataFormFinal={setDataFinal}
                  setDataForm={setDataAll || setDataForm2}
                  dataForm={dataAll || dataForm2}
                  setLevel={setLevel}
                  update={update}
                />
              )}
              {level === 3 && (
                <SigninFormMujahid3
                  setDataForm={setDataAll || setDataFinal}
                  dataForm={dataAll || dataFinal}
                  setLevel={setLevel}
                  update={update}
                />
              )}
            </Box>
          </Box>
        </>
      )}
      {level === 4 && (
        <Box display="grid" justifyItems="center" width="100%">
          <img src={done} />
          <Box mt="50px" textAlign="center">
            <Typography color="white" fontSize="25px">
              ثبت نام با موفقیت انجام شد!
            </Typography>
            <Typography color="white" fontSize="25px">
              به زودی از سوی قرارگاه جهادی اثر با شما تماس گرفته خواهد شد.
            </Typography>
            <Link to="/login">
              <Typography
                color="white"
                bgcolor="green"
                p="5px 10px"
                borderRadius="10px"
                width="fit-content"
                margin="auto"
                mt="20px"
                sx={{ cursor: "pointer" }}
              >
                {"متوجه شدم"}
              </Typography>
            </Link>
          </Box>
        </Box>
      )}
    </Box>
  );
}
